import React from 'react'

import { parseMessageLinks } from '@/shared/lib/message-links'


export function MessageWithLinks({ text }: { text: string }) {
  return (
    <>
      {parseMessageLinks(text).map((segment, index) => (
        segment.kind === 'link' ? (
          <a
            key={`${segment.url}-${index}`}
            href={segment.url}
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2 break-words"
          >
            {segment.label}
          </a>
        ) : (
          <React.Fragment key={`text-${index}`}>
            {segment.text}
          </React.Fragment>
        )
      ))}
    </>
  )
}
